import { getEdges, getPageInfo, getRelayArgs } from "../relay-pagination-mjs";
import { filterRecords, getRecords } from "../orm/records-mjs";
import { unwrapType } from "../utils-mjs";
export function resolveRelayConnection(obj, args, context, info, type) {
  var _type$getFields = type.getFields(),
      edgesField = _type$getFields.edges;

  var _unwrapType = unwrapType(edgesField.type),
      edgeType = _unwrapType.type;

  var _getRelayArgs = getRelayArgs(args),
      relayArgs = _getRelayArgs.relayArgs,
      nonRelayArgs = _getRelayArgs.nonRelayArgs;

  var _unwrapType2 = unwrapType(edgeType.getFields().node.type),
      nodeType = _unwrapType2.type;

  var records = obj && obj[info.fieldName] && obj[info.fieldName].models ? filterRecords(obj[info.fieldName].models, nonRelayArgs) : getRecords(nodeType, nonRelayArgs, context.mirageSchema);
  var edges = getEdges(records, relayArgs, nodeType.name);
  return {
    edges: edges,
    pageInfo: getPageInfo(records, edges),
    totalCount: records.length
  };
}
